module.exports = __webpack_public_path__ + "static/img/Tech_04.f93f070d.png";